/* unplugin-vue-components disabled */import script from "./ScreenFull.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenFull.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenFull.vue?vue&type=style&index=0&id=133a8314&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133a8314"]])

export default __exports__